import { NgModule } from '@angular/core';
import { CbCardFieldDirective } from './cb-card-field.directive';

@NgModule({
    imports: [CbCardFieldDirective],
    exports: [CbCardFieldDirective],
})
export class SharedChargebeeModule {}

